import React, { useState, useEffect } from "react";

import { withStyles } from "@material-ui/core/styles";
import ErrorIcon from '@material-ui/icons/Error';
import { Storage } from "aws-amplify";

import { utilGetVehicleImage } from "../../common/util";
import { Chip } from "@material-ui/core";

Storage.configure({
  AWSS3: {
    bucket: "calbitwebappuploadbucket1254-dev", //Your bucket name;
    region: "us-east-2" //Specify the region your bucket was created in;
  }
});
const styles = {
  card: {
    maxWidth: 345
  },
  media: {
    height: 140
  }
};
function VehicleCard(props) {
  // Supposing your item shape is something like {name: 'foo'}
  const { item, classes } = props;
  let src = "";
  const [url, setUrl] = useState("");
  const getUrl = async key => {
    let url = await Storage.get(key);
    setUrl(url);
  };
  let width = 80;
  src = utilGetVehicleImage(item.vehCategory);
  const changeRoute = () => {
    item.history.push("/company/vehicle/" + item.id);
  };
  const itemStyle = {
    display: "block",

    width: "100%",
    height: "100%",
    padding: "5px",

    backgroundColor: "white",
    cursor: "pointer",

    boxShadow: "0 4px 8px 0 rgba(0,0,0,0.2)",
    transition: "0.3s",
    borderRadius: "5px",
    "&:hover": {
      boxShadow: "0 8px 16px 0 rgba(0,0,0,0.2)"
    }
  };

  const name = {
    width: "100%",
    height: "60%",
    paddingTop: 8,
    paddingLeft: 8,
    paddingRight: 8,
    position: "relative",
    color: "#555",
    fontSize: "0.8em",
    lineHeight: "1.5",
    textTransform: "capitalize",
    cursor: "pointer"
  };
  useEffect(() => {
    if (item.mainPic) getUrl(item.mainPic.key);
    else setUrl(utilGetVehicleImage(item.vehCategory));
  }, []);
  return (
    <div style={itemStyle} onClick={changeRoute}>
      <img src={url} style={{ width: "100%" }}></img>
      <div style={name}>
        <span style={{ float: "left", paddingRight: "10px" }}>
          ID: <b>{item.customerVehicleId + "  "}</b>
        </span>
        <span style={{ float: "left" }}>
          Defects: <b>{item.defectCount}</b>
        </span>
        <span style={{ float: "left", paddingRight: "2px" }}>
          Inspection Due:
        </span>
        <span style={{ float: "left" }}>
          <b>{item.nextInspectionDue[0].nextDueDate}</b>
        </span>
        {item.deactivateBIT && item.regType !== "FEDERAL" && (
          <span style={{ margin: "10%" }}>
            <Chip label="BIT Deactivated" color="secondary" />
          </span>
        )}
        {item.redTag && (
          <span style={{ color:"red", float: "left" }}>
          <p>Red Tagged</p>
        </span>
        )}
      </div>
    </div>
  );
}
export default withStyles(styles)(VehicleCard);



// WEBPACK FOOTER //
// ./src/components/Dashboard/VehicleCard.js